<template>
  <div class="segment-mode">
    <el-radio-group :value="mode" :disabled="disabled" @input="$emit('update:mode', $event)">
      <el-radio
        v-for="item in options"
        :key="item.value"
        :label="item.value"
      >
        {{ item.label }}
      </el-radio>
    </el-radio-group>
    <div v-if="mode === 'FIXED_COUNT'" class="segment-mode__count">
      <span>均分段数</span>
      <el-input-number
        :value="segmentCount"
        :min="2"
        :max="200"
        :disabled="disabled"
        size="small"
        controls-position="right"
        @change="$emit('update:segmentCount', $event || 2)"
      />
    </div>
  </div>
</template>

<script>
import { SEGMENT_MODE_OPTIONS } from '../constants/segmentModes';

export default {
  name: 'SegmentModeSelector',
  props: {
    mode: { type: String, default: 'FIXED_DURATION' },
    segmentCount: { type: Number, default: 10 },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      options: SEGMENT_MODE_OPTIONS,
    };
  },
};
</script>

<style scoped>
.segment-mode {
  margin-bottom: 8px;
}
.segment-mode__count {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  font-size: 13px;
}
</style>
